import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-component',
  templateUrl: './confirm.component.html',
  styles: [
    `
      .confirm-prompt {
        white-space: pre-line;
      }
      :host ::ng-deep .confirm-prompt__alert {
        color: #8b0000;
        margin-bottom: 0.5rem;
      }
    `,
  ]
})
export class ConfirmComponent implements OnInit {

  title: string = null;
  prompt: string = 'Are you sure?';
  cancelBtnClass: string = 'btn-outline-primary';
  okBtnClass: string = 'btn-primary';
  cancelBtnText: string = 'Cancel';
  okBtnText: string = 'OK';
  cancelBtnIcon: string = null;
  okBtnIcon: string = null;
  reasonLabel: string = null;
  reasonPlaceholder: string = '';
  reasonRequired: boolean = false;
  reasonText: string = '';
  reasonRows: number = 2;

  constructor(private modal: NgbActiveModal) { }

  get promptHasHtml(): boolean {
    if (!this.prompt) {
      return false;
    }
    return /<[^>]+>/.test(this.prompt);
  }

  ngOnInit(): void {
  }

  confirmModal(): void {
    if (this.reasonRequired && !this.reasonText?.trim()) {
      return;
    }
    this.modal.close({ reason: this.reasonText?.trim() || '' });
  }

  dismissModal(): void {
    this.modal.dismiss();
  }
}
